import { useQueueWorkflowStore } from "@elixir/stores";
import { filterIdentifierKeyMapping } from "../apply-filters-view";
import { TFilterOption, VIEW_FILTERS } from "@elixir/types";
import { capitalizeFirstLetter } from "@elixir/utils";

const ConfirmFiltersView = () => {
  const viewName = useQueueWorkflowStore((state) => state.viewName);
  const selectedFiltersOptions = useQueueWorkflowStore(
    (state) => state.selectedFiltersOptions
  );

  return (
    <div className="dr-px-16 dr-pt-16">
      <p className="dr-text-doctor-darwin-neutral-600 FootnoteBold">
        CONFIRM FILTERS FOR
      </p>
      <p className="HeadlineBold dr-mt-4">{viewName}</p>
      <div className="dr-flex dr-flex-col dr-gap-y-12 dr-mt-12">
        {Object.keys(selectedFiltersOptions)
          .filter((filter) => {
            const { options } = selectedFiltersOptions[filter];
            return !!options && options.length > 0;
          })
          .map((filter) => {
            const { options, title } = selectedFiltersOptions[filter];
            const { title: filterTitle, Icon } =
              filterIdentifierKeyMapping[title as VIEW_FILTERS];

            return (
              <SelectedFilter
                title={filterTitle}
                options={options}
                Icon={Icon}
              />
            );
          })}
      </div>
    </div>
  );
};

const SelectedFilter = ({
  options,
  title,
  Icon,
}: {
  options: TFilterOption[];
  title: string;
  Icon: React.ReactNode;
}) => {
  return (
    <div className="dr-flex dr-flex-col dr-gap-y-4">
      <div className="dr-flex dr-flex-row dr-gap-x-6 dr-text-doctor-darwin-neutral-600 dr-items-center">
        {Icon}
        <p className="BodyRegular">{title} -</p>
      </div>
      <div className="dr-flex dr-flex-row dr-gap-x-4">
        {options.map(({ display_text, value }) => {
          const title = (display_text || value).toString();
          const sanitizedTitle = capitalizeFirstLetter(
            title.replace("_", " ").replace(/[^a-zA-Z0-9 ₹\[\]]/g, "")
          );
          return <SelectedValue title={sanitizedTitle} />;
        })}
      </div>
    </div>
  );
};

const SelectedValue = ({ title }: { title: string }) => {
  return (
    <p className="dr-px-8 dr-py-6 BodyRegular dr-rounded-4 dr-bg-darwin-touch-neutral-50 dr-text-doctor-darwin-neutral-800">
      {title}
    </p>
  );
};

export default ConfirmFiltersView;
